module.exports = __webpack_public_path__ + "img/freespin4.8a0573a2.png";